import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import ButtonBase from '@material-ui/core/ButtonBase';
import Typography from '@material-ui/core/Typography';

import IconPlus from 'components/icons/IconPlus';

const styles = theme => ({
  root: {
    width: 288,
  },
  paper: {
    height: '100%',
    padding: 0,
    borderRadius: 6,
  },
  button: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    padding: 24,
    height: '100%',
    width: '100%',
    minHeight: 297,
    color: theme.palette.primary.A400,
    border: `1px solid ${theme.palette.primary.A100}`,
    borderRadius: 6,
    transition: theme.transitions.create(['border-color'], {
      duration: theme.transitions.duration.short,
    }),
    '&:hover': {
      borderColor: theme.palette.primary[500],
    },
  },
  typographyTitle: {
    textTransform: 'uppercase',
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 140,
    height: 140,
    marginBottom: 30,
    borderRadius: 4,
    border: `1px dashed ${theme.palette.primary.A400}`,
    backgroundColor: theme.palette.grey[100],
  },
  iconPlus: {
    width: 49,
    height: 49,
  },
});

const TemplatesListItemCreate = ({ onClick, classes }) => (
  <Grid
    item
    className={classes.root}
  >
    <Paper className={classes.paper}>
      <ButtonBase
        className={classes.button}
        {...onClick ? { onClick } : {}}
      >
        <div className={classes.icon}>
          <IconPlus className={classes.iconPlus} />
        </div>
        <Typography
          className={classes.typographyTitle}
          variant="caption"
        >
          Create new template
        </Typography>
      </ButtonBase>
    </Paper>
  </Grid>
);

TemplatesListItemCreate.propTypes = {
  onClick: PropTypes.func,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    paper: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
    typographyTitle: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    iconPlus: PropTypes.string.isRequired,
  }).isRequired,
};

TemplatesListItemCreate.defaultProps = {
  onClick: null,
};

export default withStyles(styles)(TemplatesListItemCreate);



// WEBPACK FOOTER //
// ./src/components/settings/TemplatesList/TemplatesListItemCreate.js